import React from 'react'
import BookingV2 from './BookingV2'
import StoreBookings from './StoreBookings'
import ChaletBookingList from '../ChaletMaster/ChaletBooking/BookingList'
import EventBookingList from '../NewEventModule/NewEventList'
import CruiseTripBookingList from '../CruiseTripMaster/CruiseTripBookings/CruiseTripBookingList'
import { Link } from 'react-router-dom'

class AllBookings extends React.Component {
  state = {
    type: 'CRUISE',
  }

  componentDidMount = () => {
    let type = this.props.match.params.type || 'CRUISE'

    this.setState({
      type,
    })
  }

  handleChange = (event) => {
    this.setState(
      {
        [event?.target?.name]: event?.target?.value,
      },
      () => {
        window.location.href = `#/all-bookings/${this.state.type}`
      }
    )
  }

  render() {
    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-start">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div
                      className="d-inline"
                      style={{ width: 300 }}
                    >
                      <h4>Booking List</h4>
                    </div>
                    <select
                      name="type"
                      className="form-control m-l-30"
                      value={this.state.type}
                      onChange={this.handleChange}
                    >
                      <option value={'CRUISE'}>CRUISE</option>
                      <option value={'EVENT'}>EVENT</option>
                      <option value={'CHALET'}>CHALET</option>
                      {localStorage.getItem('loged_In_role') != 'concierge' && (
                        <>
                          <option value={'CRUISE_TRIP'}>TRIPS(CRUISE)</option>
                          <option value={'STORE'}>STORE</option>
                        </>
                      )}
                    </select>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Booking List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {this.state.type === 'CRUISE' && <BookingV2></BookingV2>}
            {this.state.type === 'EVENT' && <EventBookingList></EventBookingList>}
            {this.state.type === 'CHALET' && <ChaletBookingList></ChaletBookingList>}
            {localStorage.getItem('loged_In_role') != 'concierge' && (
              <>
                {this.state.type === 'CRUISE_TRIP' && <CruiseTripBookingList></CruiseTripBookingList>}
                {this.state.type === 'STORE' && <StoreBookings></StoreBookings>}
              </>
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default AllBookings
